module.exports = __webpack_public_path__ + "static/images/route-path-disabled.svg";